export default "__VITE_ASSET__C9sLjyx4__"